import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { SimplePanel } from 'web-ui-components/lib/layout/content';
import { retryStyles } from './RetryStyles';

export const Retry = ({ message, buttonText, onRetry }) => (
	<div className={retryStyles}>
		<SimplePanel>
			<div className="retry">
				<div className="retry__message">
					<span>{message}</span>
				</div>
				<div className="retry__buttonContainer">
					<Button id="retry-button" width="full" display="primary" onClick={onRetry}>
						{buttonText}
					</Button>
				</div>
			</div>
		</SimplePanel>
	</div>
);

Retry.propTypes = {
	message: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,
	onRetry: PropTypes.func.isRequired,
};
